import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Checkbox,
  Group,
  Select,
  Stack,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { Controller, useForm } from "react-hook-form";
import { useMeters } from "../../../hooks/useMeters";
import { meterSchema } from "../../../schemas/meter.schema";

export default function AddEditMeterForm() {
  const { useAddEditMeter, onCancel } = useMeters();
  const { loading, submitData, propertySelectData } = useAddEditMeter();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      meterNumber: "",
      expiry: "",
      msisdn: undefined,
      model: "",
      iccid: undefined,
      moreDetails: "",
      propertyId: "",
      wra: false,
      latitude: "",
      longitude: "",
      tariff: undefined,
    },
    resolver: yupResolver(meterSchema),
  });

  return (
    <Box>
      <Box bg={"#7CC5CF"} w={"100%"} px={"md"} py={"xs"}>
        <Text fw={600} size="lg" c={"white"}>
          Add Meter
        </Text>
      </Box>
      <Box
        p={"md"}
        style={{ maxHeight: "calc(100vh - 50px)", overflowY: "auto" }}
      >
        <form
          onSubmit={handleSubmit((values) => {
            submitData({
              values,
              onSuccess() {
                reset();
              },
            });
          })}
        >
          <Stack>
            <TextInput
              label="Meter No."
              placeholder="Meter no."
              {...register("meterNumber")}
              error={errors.meterNumber?.message}
              withAsterisk
            />
            <Controller
              name="expiry"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <DatePickerInput
                  label="Expiry year"
                  placeholder="Select year"
                  {...field}
                  value={field.value ? new Date(field.value) : null}
                  error={error?.message}
                  withAsterisk
                />
              )}
            />
            <TextInput
              label="MSISDN"
              placeholder="MSISDN"
              {...register("msisdn")}
              error={errors.msisdn?.message}
              withAsterisk
            />
            <TextInput
              label="Model"
              placeholder="model"
              {...register("model")}
              error={errors.model?.message}
              withAsterisk
            />
            <TextInput
              label="ICCID"
              placeholder="ICCID"
              {...register("iccid")}
              error={errors.iccid?.message}
            />
            <TextInput
              label="Latitude"
              placeholder="e.g. -1.254"
              {...register("latitude")}
              error={errors.latitude?.message}
              withAsterisk
            />
            <TextInput
              label="Longitude"
              placeholder="e.g. 36.5588"
              {...register("longitude")}
              error={errors.longitude?.message}
              withAsterisk
            />
            <Controller
              name="propertyId"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Select
                  label="Property registered to"
                  placeholder="Select property"
                  data={propertySelectData}
                  {...field}
                  value={field.value || null}
                  error={error?.message}
                  withAsterisk
                />
              )}
            />
            <TextInput
              label="Tariff"
              placeholder="Tariff"
              type="decimal"
              {...register("tariff")}
              error={errors.tariff?.message}
            />
            <Textarea
              label="More details"
              placeholder="Add more details"
              {...register("moreDetails")}
              error={errors.moreDetails?.message}
            />
            <Controller
              name="wra"
              control={control}
              render={({ field }) => (
                <Checkbox
                  label="WRA"
                  checked={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            <Group justify="space-between">
              <Button
                variant="light"
                disabled={loading}
                onClick={() => {
                  onCancel({
                    action() {
                      reset();
                    },
                  });
                }}
              >
                Cancel
              </Button>
              <Button type="submit" loading={loading}>
                Create
              </Button>
            </Group>
          </Stack>
        </form>
      </Box>
    </Box>
  );
}
